@if (loadingFlightChecklistTemplate) {
  <div class="accordion" id="accordion-checklist">
    @for (number of [].constructor(3); track $index; let i = $index) {
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse-' + i"
            >
            <div class="placeholder w-100"></div>
          </button>
        </h2>
        <div [id]="'collapse-' + i" class="accordion-collapse collapse show">
          <ul class="list-group list-group-flush">
            @for (number2 of [].constructor(3); track $index) {
              <li class="list-group-item">
                <div class="placeholder w-100"></div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  </div>
}
@if (!loadingFlightChecklistTemplate && !flightChecklistTemplate) {
  <div class="alert alert-warning text-center mb-0" [innerText]="'FLIGHT_CHECKLISTS.NO_TEMPLATE_FOR_DEPARTMENT' | translate"></div>
}
@if (!loadingFlightChecklistTemplate && flightChecklistTemplate) {
  <div
    class="accordion"
    id="accordion-checklist"
    >
    @for (module of flightChecklistTemplate?.modules; track module; let i = $index) {
      <div
        class="accordion-item"
        >
        <h2 class="accordion-header">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse-' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse-' + i"
            [innerText]="module.title"
          ></button>
        </h2>
        <div [id]="'collapse-' + i" class="accordion-collapse collapse show">
          <ul class="list-group list-group-flush">
            @for (field of module.fields; track field) {
              @if (flightChecklistFieldValuesById[field.id]) {
                <li
                  class="list-group-item"
                        [class.list-group-item-warning]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.warning
                        "
                        [class.list-group-item-danger]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.danger
                        "
                        [class.list-group-item-success]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.success
                        "
                        [class.list-group-item-info]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.info
                        "
                        [class.list-group-item-primary]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.primary
                        "
                        [class.list-group-item-secondary]="
                            flightChecklistFieldValuesById[field.id].selectedOption?.status ===
                            EnumFlightChecklistTemplateFieldOptionStatus.secondary
                        "
                  >
                  @if (editingChecklistFieldId !== field.id) {
                    <div class="checklist-field">
                      <div class="btn-toolbar">
                        <div class="btn-group">
                          @if (
                            flightChecklistFieldValuesById[field.id].history.length
                            ) {
                            <button
                              type="button"
                              class="btn btn-light btn-sm"
                              appTooltip="Historique"
                              (click)="showFieldHistory(field.id)"
                              >
                              <fa-icon [icon]="faClockRotateLeft"></fa-icon>
                            </button>
                          }
                          @if (hasAclAccess(EnumAcl.flightChecklistsEdit)) {
                            <button
                              type="button"
                              class="btn btn-light btn-sm"
                              appTooltip="Éditer"
                              (click)="editChecklistField(field.id)"
                              >
                              <fa-icon [icon]="faEdit"></fa-icon>
                            </button>
                          }
                        </div>
                      </div>
                      <div
                        class="checklist-field-label"
                        [innerText]="flightChecklistFieldValuesById[field.id].field.text"
                      ></div>
                      @if (
                        flightChecklistFieldValuesById[field.id].field.type !==
                        EnumFlightChecklistTemplateFieldType.select
                        ) {
                        <div
                          class="checklist-field-value"
                          >
                          @if (flightChecklistFieldValuesById[field.id].value?.value) {
                            <span
                                    [innerText]="
                                        flightChecklistFieldValuesById[field.id].value.value
                                    "
                            ></span>
                          }
                          @if (!flightChecklistFieldValuesById[field.id].value?.value) {
                            <em
                              class="text-muted"
                              >{{ 'GENERAL.EMPTY' | translate }}</em
                              >
                            }
                          </div>
                        }
                        @if (
                          flightChecklistFieldValuesById[field.id].field.type ===
                          EnumFlightChecklistTemplateFieldType.select
                          ) {
                          <div
                            class="checklist-field-value"
                            >
                            @if (flightChecklistFieldValuesById[field.id].selectedOption) {
                              <span
                                    [innerText]="
                                        $safeNavigationMigration(flightChecklistFieldValuesById[field.id].selectedOption
                                            ?.text)
                                    "
                              ></span>
                            }
                            @if (!flightChecklistFieldValuesById[field.id].selectedOption) {
                              <em
                                class="text-muted"
                                >{{ 'GENERAL.EMPTY' | translate }}</em
                                >
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (
                        editingChecklistFieldId !== field.id &&
                        showHistoryFieldId === field.id
                        ) {
                        <ul
                          class="list-group mt-2"
                          >
                          @for (
                            item of flightChecklistFieldValuesById[field.id].history
                            ; track
                            item) {
                            <li
                              class="list-group-item"
                                [class.list-group-item-warning]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.warning
                                "
                                [class.list-group-item-danger]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.danger
                                "
                                [class.list-group-item-success]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.success
                                "
                                [class.list-group-item-info]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.info
                                "
                                [class.list-group-item-primary]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.primary
                                "
                                [class.list-group-item-secondary]="
                                    getFieldStatusFromOption(field.id, item.value) ===
                                    EnumFlightChecklistTemplateFieldOptionStatus.secondary
                                "
                              >
                              <strong
                                [innerText]="getFieldValueFromOption(field.id, item.value)"
                              ></strong>
                              par
                              <a
                                [routerLink]="'/admin/users/' + item.userId"
                                target="_blank"
                                [innerText]="item.userFullName"
                              ></a>
                              le {{ item.date | date : "dd/MM/yyyy à HH:mm" }}
                            </li>
                          }
                        </ul>
                      }
                      @if (editingChecklistFieldId === field.id) {
                        <div class="checklist-field">
                          <div
                            class="checklist-field-label"
                            [innerText]="flightChecklistFieldValuesById[field.id].field.text"
                          ></div>
                          <div class="checklist-field-value">
                            @if (
                              field.type === EnumFlightChecklistTemplateFieldType.select
                              ) {
                              <div
                                class="form-group mb-0"
                                >
                                <div class="input-group">
                                  <select
                                    class="form-select"
                                    [id]="'checklist-field-' + field.id"
                                            [(ngModel)]="
                                                flightChecklistFieldValuesById[field.id].value.value
                                            "
                                    >
                                    <option
                                      [ngValue]="null"
                                                [innerText]="
                                                    'GENERAL.PLEASE_SELECT_ONE' | translate
                                                "
                                    ></option>
                                    @for (option of field.options; track option) {
                                      <option
                                        [value]="option.id"
                                        [innerText]="option.text"
                                      ></option>
                                    }
                                  </select>
                                  <button
                                    type="button"
                                    class="btn btn-danger"
                                    [appTooltip]="'GENERAL.CANCEL' | translate"
                                    (click)="clearEditChecklistField()"
                                    >
                                    <fa-icon [icon]="faCancel"></fa-icon>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-success"
                                    [appTooltip]="'GENERAL.SAVE' | translate"
                                    (click)="saveEditChecklistField()"
                                    >
                                    <fa-icon [icon]="faCheck"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            }
                            @if (
                              field.type !== EnumFlightChecklistTemplateFieldType.select
                              ) {
                              <div
                                class="form-group mb-0"
                                >
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [id]="'checklist-field-' + field.id"
                                            [(ngModel)]="
                                                flightChecklistFieldValuesById[field.id].value.value
                                            "
                                    />
                                  <button
                                    type="button"
                                    class="btn btn-danger"
                                    [appTooltip]="'GENERAL.CANCEL' | translate"
                                    (click)="clearEditChecklistField()"
                                    >
                                    <fa-icon [icon]="faCancel"></fa-icon>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-success"
                                    [appTooltip]="'GENERAL.SAVE' | translate"
                                    (click)="saveEditChecklistField()"
                                    >
                                    <fa-icon [icon]="faCheck"></fa-icon>
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </li>
                  }
                }
              </ul>
            </div>
          </div>
        }
      </div>
    }
